// extracted by mini-css-extract-plugin
export default {"list":"reward-configs-list_list__stJve","buttons":"reward-configs-list_buttons__dXTDg","pager":"reward-configs-list_pager__dBJFW"};